import Charts from "./components/Charts/index";

import "./App.css";

const App = () => {
  return (
    <div className="App">
      <Charts />
    </div>
  );
};

export default App;
